import { put, takeEvery, call } from 'redux-saga/effects';
import { PasswordResetActions } from './actions';
import ApiService from '../../../Services/ApiService';

export function* requestReset(action) {
  try {
    const { email, captcha } = action.payload;
    yield call(ApiService.requestPasswordReset, { email, captcha });
    yield put(PasswordResetActions.requestResetSucceeded());
  } catch (e) {
    yield put(PasswordResetActions.requestResetFailed({ error: e?.response?.data?.error || 'network_error' }));
  }
}

export function* watchPasswordReset() {
  yield takeEvery(PasswordResetActions.requestReset, requestReset);
}
